import { Component } from "react";
import CompanyCard from "../items/CompanyCard";
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import * as L from "leaflet"
import Loading from "../commons/Loading";

class Company extends Component {

    constructor(props) {
        super(props);

        this.state = {
            companyDetail: null
        }

        console.log("auz")
    }

    componentDidUpdate() {
        disp()
    }

    componentDidMount() {
        const guid = window.location.href.split('/')[5]
        fetch("http://localhost:8080/api/company/info?companyGUID=" + guid)
            .then(res => res.json())
            .then((data) => {
                this.setState({ companyDetail: data })
            })
            .catch(console.log)
    }

    render() {

        if (this.state.companyDetail == null)
            return (<Loading/>)
        else {

            //  Create the Icon
            const LeafIcon = L.Icon.extend({
                options: {
                    iconAnchor: [23, 39],
                    iconSize: [23, 39],
                    popupAnchor: [-12, -38],
                }
                
            });
            const businessUnitIcon = new LeafIcon({
                iconUrl:
                    "https://chart.googleapis.com/chart?chst=d_map_xpin_icon&chld=pin_star|home|422c83|FF0000"
            });
            const hasBusinessUnits = this.state.companyDetail.businessUnits[0]?.gps?.lat != null
            const businessUnitsCount = this.state.companyDetail.businessUnits.length


            //const rik = (this.state.companyDetail.businessUnits[0]?.gps.lat)?"a":"b"

            const startLatitude = this.state.companyDetail.businessUnits.filter(bu => (bu.gps != null))[0]?.gps.lat
            const startLongituted = this.state.companyDetail.businessUnits.filter(bu => (bu.gps != null))[0]?.gps.long

            return (

                <div className="container-fluid">
                    <div className="container px-4 mt-4">
                        <span className="breadcrumb-item active"></span>
                        <div className="row">

                            <div className="col mb-2">
                                <h2>{this.state.companyDetail.company.name}</h2>
                                <ol className="breadcrumb mb-4">
                                    <li className="breadcrumb-item active">Company resume</li>
                                </ol>
                            </div>
                            <div className="col mb-2 text-end">
                                <div className="btn-group ">
                                    <a href="#" className="btn btn-primary active" aria-current="page"><i className="fa-solid fa-eye"></i> Dashboard</a>
                                    <a href="#" className="btn btn-success"><i className="fa-solid fa-bolt"></i> Manage</a>
                                    <a href="#" className="btn btn-dark"><i className="fa-solid fa-gear"></i> Settings</a>
                                </div>
                            </div>
                        </div>
                        <div className="card bg-black bg-opacity-10 text-white mb-4">
                            <div className="card-header">
                                <i className="fas fa-table me-1"></i>
                                Informazioni
                            </div>
                            <div className="card-body">
                                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3">
                                    <p>Owner:</p>
                                    <p>P.IVA:<br /> <span className="breadcrumb-item active">{this.state.companyDetail.company.vat}</span></p>
                                    <p>ID:  <br />
                                        <span className="breadcrumb-item active">{this.state.companyDetail.company.guid}</span>
                                    </p>

                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-6 col-md-6">
                                <div className="row">
                                    <div className="col-xl-6">
                                        <div className="card bg-primary text-white mb-4">
                                            <div className="card-body">20 activities</div>
                                            <div className="card-footer d-flex align-items-center justify-content-between">
                                                <a className="small text-white stretched-link" href="#">View Details</a>
                                                <div className="small text-white"><i className="fas fa-angle-right"></i></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6">
                                        <div className="card bg-success text-white mb-4">
                                            <div className="card-body">10 tasks completed</div>
                                            <div className="card-footer d-flex align-items-center justify-content-between">
                                                <a className="small text-white stretched-link" href="#">View Details</a>
                                                <div className="small text-white"><i className="fas fa-angle-right"></i></div>
                                            </div>
                                        </div>
                                        <div className="card bg-danger text-white mb-4">
                                            <div className="card-body">10 tasks completed</div>
                                            <div className="card-footer d-flex align-items-center justify-content-between">
                                                <a className="small text-white stretched-link" href="#">View Details</a>
                                                <div className="small text-white"><i className="fas fa-angle-right"></i></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="col-xl-6 col-md-6">
                                <div className="card mb-4 bg-black bg-opacity-10">
                                    <div className="card-header">
                                        Process flows
                                    </div>
                                    <div className="card-body"> <canvas id="myPieChart" width="100%" height="50"></canvas></div>
                                    <div className="card-footer small text-muted">Updated yesterday at 11:59 PM</div>
                                </div>
                            </div>
                        </div>







                        <div className="card bg-black bg-opacity-10 text-white mb-4">
                            <div className="card-header">
                                <i className="fas fa-table me-1"></i> Business Units ({businessUnitsCount})
                            </div>
                            <div className="card-body">
                                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4  row-cols-xl-5">
                                    {this.state.companyDetail.businessUnits.map(bu => (
                                        <CompanyCard
                                            key={bu.guid}
                                            company={bu} />

                                    ))}
                                </div>
                            </div>
                        </div>



                    </div>
                    <div>
                        {hasBusinessUnits ? (
                            <MapContainer center={[startLatitude, startLongituted]} zoom={12} scrollWheelZoom={true}>
                                <TileLayer
                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />



                                {this.state.companyDetail.businessUnits.filter(bu => (bu.gps != null)).map(bu => (
                                    <Marker position={[bu.gps.lat, bu.gps.long]} color="" icon={businessUnitIcon}>
                                        <Popup>
                                            {[bu.name]}
                                        </Popup>
                                    </Marker>
                                ))}

                            </MapContainer>
                        ) : ("")}

                    </div>



                </div>



            )

        }
    }
}

function disp() {
    const event = new Event('chart-rendered')
    document.dispatchEvent(event)


}

export default Company